export default __webpack_public_path__ + "static/benefitImg-9e0072bb0716eb4f42295717e730eb70.png";